<template>
  <div class="field">
    <label class="label">Contact Phone</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder="מספרי טלפון מופרדים בפסיק..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PositionContactPhones',
  props: {
    value: {
      type: [String],
      required: true
    },
    positionId: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    async handleChange () {
      try {
        await this.$network_utils.updatePosition({
          position_id: this.positionId,
          contact_phones: this.value
        })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
